import { AutogenModelDeductCode, AutogenRowDeductCode } from "./autogen/AutogenModelDeductCode";

export class ModelDeductCode extends AutogenModelDeductCode<RowDeductCode> {
	constructor() {
		super(RowDeductCode);
	}
}

export class RowDeductCode extends AutogenRowDeductCode {
}